import $ from 'jquery';
import {googleMap} from './google-map';
import { initMobileMenu } from './mobile-menu';
import { paintMasonryLayout } from './masonry-layout';
import { initFancyInputBox } from './fancy-input';
import { initInfiniteScroll } from './infinite-scroll';
import { formValidationEvents } from './form/form-events';
import { initStateDropDownBox } from './state-dropdown';
import { sizePicker } from './offer-size-picker';
import { newsArchive } from './news-archive';
import { initializeFeatureVideo } from './feature-video';
import { discographySubMenu } from './discography-submenu'

import { initCleaveDate } from './cleave-date';

import {mobileMasker} from './mobile-masker';
import {autocomplete} from './autocomplete';
import {initSliderPro} from './slider-pro';

import {initFanArchive} from './fan-archive-pager';
import {notification} from './notification';
import {flip} from './jquery-flip';

import { prepareMiniLightBox } from "./component/mini-lightbox/mini-lightbox-configure";

const polyfillStartWith = () => {
	if(!String.prototype.startsWith) {
		String.prototype.startsWith = function(searchString, position){
			return this.substr(position || 0, searchString.length) === searchString;
		};
	}
}

$(function () {

	polyfillStartWith();

    googleMap();
	initMobileMenu();
	paintMasonryLayout();
	initFancyInputBox();
	initInfiniteScroll();
	initStateDropDownBox();
	formValidationEvents();
	sizePicker();
	newsArchive();
	discographySubMenu();

	initCleaveDate();
	mobileMasker();
	autocomplete();
	initSliderPro();
    initializeFeatureVideo();

    initFanArchive();
    flip();
    notification();

	prepareMiniLightBox();


});

